import { Palette, Theme, createTheme } from '@mui/material'
import { breakpoints } from './breakpoints.js'

export const createTypography = (palette: Palette, hasResponsiveTypography: boolean): Theme['typography'] =>
  createTheme({
    typography: {
      h1: {
        fontStyle: 'normal',
        fontWeight: 900,
        textTransform: 'uppercase' as 'uppercase',
        fontFamily: '"Delivery Condensed Black", Calibri, Arial, sans-serif',
        fontSize: '60px',
        lineHeight: 1,
        letterSpacing: 0,
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '54.6px',
              },
            }
          : {}),
      },
      h2: {
        fontStyle: 'normal',
        fontWeight: 900,
        textTransform: 'uppercase' as 'uppercase',
        fontFamily: '"Delivery Condensed Black", Calibri, Arial, sans-serif',
        fontSize: '48px',
        lineHeight: 1,
        letterSpacing: 0,
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '32.2px',
              },
            }
          : {}),
      },
      h3: {
        fontStyle: 'normal',
        fontWeight: 700,
        fontFamily: '"Delivery Bold", Calibri, Arial, sans-serif',
        fontSize: '34px',
        lineHeight: 1,
        letterSpacing: 0,
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '30.6px',
              },
            }
          : {}),
      },
      h4: {
        fontFamily: '"Delivery Bold", Calibri, Arial, sans-serif',
        fontStyle: 'normal',
        fontSize: '20px',
        lineHeight: 1.2,
        fontWeight: 700,
        letterSpacing: 0,
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '18px',
              },
            }
          : {}),
      },
      h5: {
        fontFamily: '"Delivery Bold", Calibri, Arial, sans-serif',
        fontStyle: 'normal',
        fontSize: '16px',
        lineHeight: 1.2,
        fontWeight: 700,
        letterSpacing: 0,
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '14.4px',
              },
            }
          : {}),
      },
      h6: {
        fontFamily: '"Delivery Condensed Black", Calibri, Arial, sans-serif',
        fontStyle: 'normal',
        fontSize: '16px',
        fontWeight: 900,
        lineHeight: 1.2,
        letterSpacing: '0.015em',
        textTransform: 'uppercase' as 'uppercase',
        color: palette.grey[400],
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '14.4px',
              },
            }
          : {}),
      },
      subtitle1: {
        fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
        fontStyle: 'normal',
        fontSize: '16px',
        lineHeight: 1.4,
        fontWeight: 400,
        letterSpacing: '0.015em',
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '14.4px',
              },
            }
          : {}),
      },
      subtitle2: {
        fontFamily: '"Delivery Bold", Calibri, Arial, sans-serif',
        fontStyle: 'normal',
        fontSize: '14px',
        lineHeight: 1.4,
        fontWeight: 700,
        letterSpacing: '0.015em',
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '12.6px',
              },
            }
          : {}),
      },
      button: {
        fontFamily: '"Delivery Bold", Calibri, Arial, sans-serif',
        fontStyle: 'normal',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: 1,
        letterSpacing: 0,
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '14.4px',
              },
            }
          : {}),
      },
      caption: {
        fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: 1.2,
        letterSpacing: 0,
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '10.8px',
              },
            }
          : {}),
      },
      body1: {
        fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
        fontSize: '16px',
        fontWeight: 300,
        lineHeight: 1.4,
        letterSpacing: 0,
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '14.4px',
              },
            }
          : {}),
      },
      body2: {
        fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: 1.4,
        letterSpacing: 0,
        WebkitFontSmoothing: 'antialiased',
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '12.6px',
              },
            }
          : {}),
      },
      overline: {
        fontStyle: 'normal',
        fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '120%',
        letterSpacing: '0.025em',
        textTransform: 'uppercase' as 'uppercase',
        color: palette.grey[600],
        ...(hasResponsiveTypography
          ? {
              [breakpoints.up('sm')]: {
                fontSize: '10.8px',
              },
            }
          : {}),
      },
    },
  }).typography
